module.exports = __webpack_public_path__ + "static/fonts/iconfont.e1e0fa4c.woff";